$(document).ready(function () {
    var filterList = JSON.parse(localStorage.getItem('filterlist'));
    var $activeFiltersList = $('.active-filters-list');

    if(filterList != null && filterList.length > 0 ){
        if($activeFiltersList.length > 0){
            $(filterList).each(function (i){
                addToActiveFilterList(filterList[i]['filterName']);
            })
        }
    } else{
            $activeFiltersList.prepend('<li class="active-filters-list-item">No active filters</li>');  
            $('#clear-active-filters').remove();
    }

    function addToActiveFilterList(title){
        $activeFiltersList.prepend('<li class="active-filters-list-item">'+title +'</li>');  
    }

      $('#clear-active-filters').on('click','a', function () {
        // Clear the local storage
        filterList = [];
        localStorage.setItem("filterlist",JSON.stringify(filterList));
        // Hide the button
        $(this).hide();
        // Remove all list items
        $('.active-filters-list-item').remove();
        // Show the no active filters info
        $activeFiltersList.prepend('<li class="active-filters-list-item">No active filters</li>');  
       
    });

});